import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import * as ROUTES from '../../constants/routes';
import { AuthProvider, CompanyProvider } from '../../providers';
import { withFirebase } from '../Firebase';
import Loading from './loading';
import LoggedIn from './loggedIn';
import NotLoggedIn from './notLoggedIn';
// import { migrateLids } from './migrateLids';
// import { Button } from '@material-ui/core';
// import { checkBrokenGroups } from './checkBrokenGroups';

const ScanPageDisplay = (props) => {
   switch (props.scanInStatus) {
      case 'notLoggedIn':
         return <NotLoggedIn setScanInStatus={props.setScanInStatus} />;
      case 'loggedIn':
         return <LoggedIn user={props.user} location={props.location} />;
      default:
         return <Loading />;
   }
};

const ScanIn = (props) => {
   const user = JSON.parse(localStorage.getItem('authUser'));
   let url = queryString.parse(window.location.search);
   const [location, setLocation] = useState({});
   const [scanInStatus, setScanInStatus] = useState('loading');

   useEffect(() => {
      if (url.locName && url.loc) {
         setLocation(url);
         if (user || url.loggedIn) {
            setScanInStatus('loggedIn');
         } else {
            setScanInStatus('notLoggedIn');
         }
      } else {
         props.history.push(ROUTES.PERMISSIONDENIED);
      }
   }, [scanInStatus]);

   return (
      <AuthProvider>
         <CompanyProvider>
            <ScanPageDisplay
               user={user}
               scanInStatus={scanInStatus}
               setScanInStatus={setScanInStatus}
               location={location}
            />
            {/* <Button onClick={() => migrateLids()}>Migrate LIDs</Button> */}
            {/* <Button onClick={() => checkBrokenGroups()}>Check broken groups</Button> */}
         </CompanyProvider>
      </AuthProvider>
   );
};

const ScanInForm = compose(withRouter, withFirebase)(ScanIn);

export default ScanInForm;
